import { useMemo } from "react";
import { useProgressCount } from "../../api/progressApi";
import { translator } from "../../utils/translator";

type ProgressCount = {
  [progress: string]: {
    [department: string]: {
      [status: string]: number;
    };
  };
};

const progressOrder = [
  "attitude",
  "e_learning",
  "homework",
  "homework_score",
  "training_mandatory",
  "training_individual",
  "training_incumbent",
  "docu_post",
];

const departmentOrder = ["life", "pro"];

const StaffProgress = () => {
  const { data, isLoading: isProgressLoading } = useProgressCount();
  const progressCount: ProgressCount = useMemo(
    () => (data ? data.progress_count : {}),
    [data]
  );

  if (isProgressLoading) return <p>로딩 중...</p>;

  return (
    <div>
      <table className="table" id="progress">
        <thead>
          <tr>
            <th></th>
            <th
              colSpan={3}
              style={{ borderRight: "1px solid var(--gray-200)" }}
            >
              생활스포츠
            </th>
            <th colSpan={3}>전문스포츠</th>
          </tr>
          <tr>
            <th></th>
            <th>미처리</th>
            <th>통과</th>
            <th>총인원</th>
            <th>미처리</th>
            <th>통과</th>
            <th>총인원</th>
          </tr>
        </thead>
        <tbody>
          {progressOrder.map((progress) => (
            <tr key={progress}>
              <td>{translator[progress]}</td>
              {departmentOrder.map((department) => (
                <>
                  <td>{progressCount[progress][department].ready}</td>
                  <td>{progressCount[progress][department].approved}</td>
                  <td>{progressCount[progress][department].total}</td>
                </>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StaffProgress;
